module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon20.e9a809c0.png";